import { SxProps, Typography, TypographyProps } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

export interface Props extends TypographyProps {
  text: string;
  large?: boolean;
}



const DefaultTextBold: React.FC<Props> = ({ text, large, ...typographyProps }) => {

  const sxStyle: SxProps = {
    fontFamily: "UnimedSans-Bold",
    fontSize: large ? "20px" : "16px",
    lineHeight: "30px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#383838",
  }

  const accessibility = useAccessibility();

  return (
    <Typography
      sx={sxStyle}
      component={typographyProps.component}
      style={accessibility.textStyleAccessibility}
      dangerouslySetInnerHTML={{ __html: text }}
      {...typographyProps}
    />
  )
}

export default DefaultTextBold;